<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Readers love</span></p>
<p class="p1"><span class="t2">K</span><span class="t3">ATE</span> <span class="t2">M</span><span class="t3">C</span><span class="t2">M</span><span class="t3">URRAY</span></p>
<p class="p2"><span class="t4">The Silence of the Stars</span></p>
<p class="p3">“This is a must read for hopeless romantics….”</p>
<p class="p4">—MM Good Book Reviews</p>
<p class="p3">“I found <span class="t6">The Silence of the Stars</span> easy to read, it was sweet and gentle, and flowed well.”</p>
<p class="p4">—Prism Book Alliance</p>
<p class="p3">“I love Kate’s writing, it’s quiet and thoughtful and she gives her characters so much depth.”</p>
<p class="p5">—The Tipsy Bibliophile</p>
<p class="p2"><span class="t4">The Stars that Tremble</span></p>
<p class="p3">“<span class="t6">The Stars That Tremble</span> has so many lovely elements to its story that it can be appreciated on multiple levels.”</p>
<p class="p4">—Joyfully Jay</p>
<p class="p3">“Kate McMurray picked up my imaginary gauntlet and smacked me with it. This book was fantastic.”</p>
<p class="p5">—Live Your Life, Buy the Book</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?47981cc0